<template>
  <div class="form-group">
    <div :class="isQuestionType ? 'question-group-print' : ''">
      <component :is="componentType" v-bind="proposalItem"></component>
      <VCommentPrintList v-if="showComments" :comments="filteredComments"></VCommentPrintList>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import questionsHelper from '@shared/components/questions/utils/questionsHelper.js';
import VCommentPrintList from '@broker/puppet/comments/ui/VCommentPrintList.vue';


import QDatePrint from '@shared/components/questions/ui/print/QDatePrint.vue';
import QUploadPrint from '@shared/components/questions/ui/print/QUploadPrint.vue';
import QuestionSubSectionPrint from '@shared/components/questions/ui/print/QuestionSubSectionPrint.vue';
import QShortPrint from '@shared/components/questions/ui/print/QShortPrint.vue';
import QLongReadonly from '@shared/components/questions/ui/print/QLongReadonly.vue';
import QYesNoReadonly from '@shared/components/questions/ui/print/QYesNoReadonly.vue';
import QOptionReadonly from '@shared/components/questions/ui/print/QOptionReadonly.vue';
import QCheckReadonly from '@shared/components/questions/ui/print/QCheckReadonly.vue';
import QTablePrint from '@shared/components/questions/ui/print/QTablePrint.vue';
import QSignPrint from '@shared/components/questions/ui/print/QSignPrint.vue';

export default {
  components: {
    QDatePrint,
    QUploadPrint,
    QuestionSubSectionPrint,
    QShortPrint,
    QYesNoReadonly,
    QCheckReadonly,
    QOptionReadonly,
    QLongReadonly,
    QTablePrint,
    QSignPrint,
    VCommentPrintList,
  },
  props: {
    proposalItem: Object,
  },
  computed: {
    ...mapState('print', ['printAppendix' ]),
    isQuestionType() {
      return questionsHelper.isQuestionType(this.proposalItem.type);
    },
    filteredComments() {
      return this.$store.getters['print/comments'](this.proposalItem.id);
    },
    showComments(){
      return !this.printAppendix && this.filteredComments.length>0 ;
    },
    componentType() {
      if (this.proposalItem.type in questionsHelper.printComponentsDict()) 
        return questionsHelper.printComponentsDict()[this.proposalItem.type];

      return 'VNone';
    }
  },
};



</script>

<style scoped></style>
